import React from "react";
import CarteHorsConnexion, {
  LienEspaceClient,
} from "../../common/CarteHorsConnexion/CarteHorsConnexion";
import Control from "../../common/Control";
import Loader from "../../common/Loader";
import PasswordControl from "../../common/PasswordControl";
import Page from "../../common/layout/Page";
import useActivateAccountInvite, { ETATS } from "./useActivateAccountInvite";

// Page « Créez votre mot de passe » (PER-2398). Sert à l'invitation manuelle des
// comptes sans mot de passe (email envoyé depuis le back-office) comme à
// l'invitation « ajouter un utilisateur à ma société » : le wording reste neutre.
// Rendu seul — la logique et les appels API sont dans useActivateAccountInvite.
const ActivateAccountInvite = (props) => {
  const {
    etat,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    canSave,
    setCanSave,
    passwordsEqual,
    peutSoumettre,
    errors,
    isSaving,
    soumettre,
    reessayer,
  } = useActivateAccountInvite(props.match.params.token);

  if (etat === ETATS.DEJA_UTILISE) {
    return (
      <Page back="/">
        <CarteHorsConnexion titre="Ce lien d'invitation a déjà servi">
          <i
            className="fa fa-check-circle carte-hors-connexion__icone text-success"
            aria-hidden="true"
          />
          <p className="carte-hors-connexion__texte">
            Votre compte est activé. Connectez-vous avec le mot de passe que vous
            avez choisi. Si vous ne l'avez pas encore choisi, utilisez « Mot de
            passe oublié » sur la page de connexion.
          </p>
          <LienEspaceClient />
        </CarteHorsConnexion>
      </Page>
    );
  }

  return (
    <Page back="/">
      <CarteHorsConnexion titre="Créez votre mot de passe">
        {etat === ETATS.VERIFICATION && (
          <Loader text="Vérification de votre invitation…" />
        )}

        {etat === ETATS.INVALIDE && (
          <p className="carte-hors-connexion__alerte mb-0" role="alert">
            Ce lien d'invitation n'est plus valide. Demandez une nouvelle
            invitation à votre conseiller.
          </p>
        )}

        {etat === ETATS.INDISPONIBLE && (
          <>
            <p className="carte-hors-connexion__alerte" role="alert">
              Nous n'arrivons pas à vérifier votre invitation pour le moment.
              Réessayez dans quelques instants.
            </p>
            <button
              type="button"
              className="carte-hors-connexion__action"
              onClick={reessayer}
            >
              Réessayer
            </button>
          </>
        )}

        {etat === ETATS.SUCCES && (
          <>
            <i
              className="fa fa-check carte-hors-connexion__icone text-success"
              aria-hidden="true"
            />
            <p className="text-success font-weight-bold mb-4">
              Votre mot de passe est enregistré. Vous pouvez maintenant vous
              connecter.
            </p>
            <LienEspaceClient libelle="Se connecter" />
          </>
        )}

        {etat === ETATS.FORMULAIRE && (
          <form
            className="w-100"
            onSubmit={(e) => {
              e.preventDefault();
              soumettre();
            }}
          >
            <p className="carte-hors-connexion__texte">
              Bienvenue sur votre Espace client Perceval Assurance. Choisissez un
              mot de passe pour accéder à votre espace.
            </p>
            <div className="carte-hors-connexion__champs">
              <Control
                label="Votre mot de passe"
                type="password"
                name="password"
                autocomplete="new-password"
                autoFocus
                value={password}
                change={(e) => setPassword(e.target.value)}
                error={errors}
                isValid={!errors.password && password !== "" && canSave}
              />
              <PasswordControl
                style={{}}
                password={password}
                minLength={6}
                minUppercase={1}
                minLowercase={3}
                minNumber={1}
                setCanSave={setCanSave}
              />
              <Control
                label="Confirmez votre mot de passe"
                type="password"
                name="passwordConfirm"
                autocomplete="new-password"
                value={passwordConfirm}
                change={(e) => setPasswordConfirm(e.target.value)}
                error={errors}
                isValid={!errors.passwordConfirm && passwordConfirm !== ""}
              />
              {passwordConfirm.length > 0 && passwordsEqual && (
                <div className="carte-hors-connexion__ok">
                  <i className="fa fa-check-circle mr-2" aria-hidden="true" />
                  <span>Les mots de passe correspondent.</span>
                </div>
              )}
              {errors.other && (
                <p className="carte-hors-connexion__alerte mt-2 mb-0" role="alert">
                  {errors.other}
                </p>
              )}
              <button
                className="carte-hors-connexion__action mt-3"
                type="submit"
                disabled={!peutSoumettre}
              >
                <i className="fa fa-shield-alt mr-2" aria-hidden="true" />
                {isSaving ? "Enregistrement…" : "Créer mon mot de passe"}
              </button>
            </div>
          </form>
        )}
      </CarteHorsConnexion>
    </Page>
  );
};

export default ActivateAccountInvite;
